<template>
  <div class="history">
    <v-base-card>
      <template v-slot:heading>
        申し込み履歴
      </template>

      <template v-slot:content>
        <v-data-table
          :headers="headers.filter(header => header.display)"
          :items="histories"
          :loading="loading"
          loading-text="Loading... Please wait"
          :options.sync="pagination"
          :height="300"
          hide-default-footer
        >
          <template #[`item.subject_name`]="{ item }">
            <v-subject-chip
              :type="subjects.find(subject => subject.name === item.subject_name).code"
            >
              {{ item.subject_name }}
            </v-subject-chip>
          </template>
          <template #[`item.status_i18n`]="{ item }">
            <v-chip dark class="my-1 mx-2"
              :class="getStatusClass(statuses.find(s => s.name === item.status_i18n).code)"
            >
              {{item.status_i18n}}
            </v-chip>
          </template>
          <template #[`item.details`]="{ item }">
            <v-btn small color="secondary" dark @click.stop="showDetail(item)">
              確認
            </v-btn>
          </template>
          <template #[`item.preview`]="{ item }">
            <v-btn small color="secondary" dark @click.stop="showImage(item)">
              確認
            </v-btn>
          </template>
          <template #[`item.w-e-export`]="{ item }">
            <v-btn v-if="item.code === null" small color="secondary" dark @click.stop="wordExcelDownload(item)">
              出力
            </v-btn>
          </template>
          <template #[`item.individual-file-download`]="{ item }">
            <v-btn small color="secondary" dark @click.stop="individualFileDownload(item)">
              出力
            </v-btn>
          </template>
        </v-data-table>
        <v-pagination
          v-model="pagination.page"
          :length="pages"
          color="secondary"
        />
      </template>

    </v-base-card>

    <v-photo-swipe
      :isOpen="previewDialog && previewImages && previewImages.length !== 0"
      :items="previewImages || []"
      :options="photoswipeOptions"
      @close="previewDialog = !previewDialog" />

    <v-dialog
      v-if="selectedHistory"
      v-model="detailDialog"
      persistent
      max-width="400px"
    >
      <v-card
        min-height="150px"
      >
        <v-toolbar
          class="title"
        >{{selectedHistory.grade_name}} {{selectedHistory.subject_name}}</v-toolbar>

        <v-card-text class="px-5">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left pl-1 py-2 th_top">大問番号</th>
                  <th class="text-left pl-1 py-2 th_top">大問管理番号</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="content in selectedHistory.sheet_content_pages" :key="content.number">
                  <td class="text-left pl-1 py-2 td_top">{{content.number}}</td>
                  <td class="text-left pl-1 py-2 td_top">{{content.content_short_code}}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>

        <v-card-actions class="card-action">
          <v-spacer></v-spacer>
          <v-btn color="gray" class="dialog-Button" @click="detailDialog = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ファイルダウンロードモーダル -->
    <v-file-download-modal ref="fileDownloadModal" />
  </div>
</template>

<script>
import VBaseCard from '@/components/molecules/BaseCard'
import VSubjectChip from '@/components/atoms/SubjectChip'
import VPhotoSwipe from '@/components/atoms/PhotoSwipe'
import VFileDownloadModal from '@/components/molecules/FileDownloadModal'

export default {
  components: {
    VBaseCard,
    VSubjectChip,
    VPhotoSwipe,
    VFileDownloadModal,
  },
  data () {
    return {
      previewDialog: false,
      headers: [
        { text: '試験名', align: 'start', sortable: false, value: 'sheet_name', display: true },
        { text: '学年', align: 'center', value: 'grade_name', sortable: false, display: true },
        { text: '教科', align: 'center', value: 'subject_name', sortable: false, display: true },
        { text: `${this.$store.getters['user/isFree'] ? '問題作成完了日' : '申込日'}`, align: 'center', value: 'created_at', display: true },
        { text: '状態', align: 'center', value: 'status_i18n', sortable: false, display: !this.$store.getters['user/isFree'] },
        { text: '問題内容', align: 'center', value: 'details', sortable: false, display: !this.$store.getters['user/isFree'] },
        { text: 'プレビュー', align: 'center', value: 'preview', sortable: false, display: true },
        { text: 'Word・Excel出力', align: 'center', value: 'w-e-export', sortable: false, display: this.$store.getters['user/isFree'] },
        { text: '個別ファイル出力', align: 'center', value: 'individual-file-download', sortable: false, display: this.$store.getters['user/isFree'] },
      ],
      loading: false,
      pagination: {
        itemsPerPage: 5
      },
      histories: [],
      statuses: [
        { code: null, name: '全て' },
        { code: 'not-done', name: '未処理' },
        { code: 'processing', name: '内容確認中' },
        { code: 'free', name: '無料' },
        { code: 'done', name: '処理済み' },
        { code: 'delete', name: '取消' },
        { code: 'demo', name: 'お試し利用' },
      ],
      // preview
      photoswipeOptions: {
        index: 0,
      },
      previewImages: [],
      detailDialog: false,
      selectedHistory: null,
    }
  },

  async mounted() {
    await this.getHistories()
  },

  computed: {
    subjects() {
      return this.$store.getters['master/subjectBases']
    },
    pages() {
      return this.pagination.itemsPerPage ? Math.ceil(this.histories.length / this.pagination.itemsPerPage) : 0
    },
  },

  methods: {
    getStatusClass(status) {
      let className = 'chip__status'
      if (status === 'not-done') return className + '-applicate'
      else if (status === 'done') return className + '-contracted'
      else if (status === 'delete') return className + '-deleted'
      else if (status === 'processing') return className + '-processing'
      else if (status === 'demo') return className + '-demo'
      else if (status === 'free') return className + '-free'
      else return className + '-shipped'
    },

    async pdfDownloadAndShow(mode) {
      this.previewImages = null
      this.$app.$refs.loading.open({type: 'print', message: 'プレビュー作成中'})
      await this.$store.dispatch('sheet/getSheetImages', {params:{type:mode}})
      const questionFilePaths = this.$store.state.sheet.questionImages
      const answerFilePaths = this.$store.state.sheet.answerImages
      this.previewImages = this.makePreviewImages({ questionFilePaths, answerFilePaths })
      this.$app.$refs.loading.close({})
    },

    async showImage(history) {
      this.previewImages = history.file_paths.map(path => {
        return { src: this.$axios.defaults.baseURL + path, w: 900, h: 600 }
      })
      this.previewDialog = !this.previewDialog
    },

    async getHistories() {
      this.loading = true
      const res = await this.$axios(('/api/v1/teacher/requests' ))
      this.histories = res.data
      this.loading = false
    },

    showDetail(item){
      this.detailDialog = true
      this.selectedHistory = item
    },

    async wordExcelDownload(item){
      this.$app.$refs.loading.open({type: 'print', message: '出力中'})

      // data取得
      const res = await this.$axios.post('/api/v1/teacher/requests/' + item.id + '/create_free_zip',
        {}, {
          responseType: 'blob', dataType: 'binary'
        })
      const blob = new Blob([res.data], { type: res.data.type })
      //レスポンスヘッダからファイル名を取得
      const contentDisposition = res.headers['content-disposition']
      let fileName = contentDisposition.substring(contentDisposition.indexOf("''") + 2,
                                                    contentDisposition.length
                                                 )
      //デコードするとスペースが"+"になるのでスペースへ置換
      fileName = decodeURI(fileName).replace(/\+/g, ' ')
      saveAs(blob, fileName)

      this.$app.$refs.loading.close({})
    },

    async individualFileDownload(item){
      const subjectCode = this.subjects.find(subject => subject.name === item.subject_name)?.code
      this.$refs.fileDownloadModal.setSheetId(item.sheet_id)
      this.$refs.fileDownloadModal.setSheetContentPages(item.sheet_content_pages)
      this.$refs.fileDownloadModal.setSubjectCode(subjectCode)
      this.$refs.fileDownloadModal.open()
    },
  }
}
</script>

<style lang="stylus" scoped>
.font-bold
  font-weight bold

.chip
  &__status
    &-applicate
      background-color #3E90C6 !important
      width 104px
      height 19px !important
      font-size 10px !important
      font-weight bold
      border-bottom 1px solid #c4c4c4
      display inline-block

    &-contracted
      background-color #4caf50 !important
      width 104px
      height 19px !important
      font-size 10px !important
      font-weight bold
      border-bottom 1px solid #337f36
      display inline-block

    &-shipped
      background-color #8e8e8e !important
      width 104px
      height 19px !important
      font-size 10px !important
      font-weight bold
      border-bottom 1px solid #6d6464
      display inline-block

    &-deleted
      background-color #808080 !important
      width 104px
      height 19px !important
      font-size 10px !important
      font-weight bold
      border-bottom 1px solid #696767
      display inline-block

    &-processing
      background-color #c44c32 !important
      width 104px
      height 19px !important
      font-size 10px !important
      font-weight bold
      border-bottom 1px solid #8a1c1c
      display inline-block

    &-demo
      background-color: #808080 !important;
      width: 104px;
      height: 19px !important;
      font-size: 10px !important;
      font-weight: bold;
      border-bottom: 1px solid #121212;
      display: inline-block;

    &-free
      background-color: #2fad5f !important;
      width: 104px;
      height: 19px !important;
      font-size: 10px !important;
      font-weight: bold;
      border-bottom: 1px solid #2a6541;
      display: inline-block;

.title
  justify-content center
  background-color: #2a5594 !important
  color white

</style>
